/**
 * #newmodmail_svc.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { Empty } from "../../../../google/protobuf/empty.js";
import { ApproveConversationResponse, ArchiveConversationResponse, BasicConversationRequest, BasicConversationsRequest, BulkReadConversationsRequest, BulkReadConversationsResponse, ConversationUserData, CreateConversationMessageRequest, CreateConversationMessageResponse, CreateConversationRequest, CreateConversationResponse, CreateModmailConversationRequest, CreateModmailConversationResponse, GetConversationRequest, GetConversationResponse, GetConversationsRequest, GetConversationsResponse, HighlightConversationResponse, MuteConversationRequest, MuteConversationResponse, SubredditsResponse, TempBanRequest, TempBanResponse, UnreadCountResponse, } from "./newmodmail_msg.js";
export const NewModmailServiceName = "devvit.plugin.redditapi.newmodmail.NewModmail";
export class NewModmailClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || NewModmailServiceName;
        this.rpc = rpc;
        this.BulkReadConversations = this.BulkReadConversations.bind(this);
        this.GetConversations = this.GetConversations.bind(this);
        this.CreateConversation = this.CreateConversation.bind(this);
        this.GetConversation = this.GetConversation.bind(this);
        this.CreateConversationMessage = this.CreateConversationMessage.bind(this);
        this.ApproveConversation = this.ApproveConversation.bind(this);
        this.ArchiveConversation = this.ArchiveConversation.bind(this);
        this.DisapproveConversation = this.DisapproveConversation.bind(this);
        this.UnhighlightConversation = this.UnhighlightConversation.bind(this);
        this.HighlightConversation = this.HighlightConversation.bind(this);
        this.MuteConversation = this.MuteConversation.bind(this);
        this.TempBan = this.TempBan.bind(this);
        this.UnarchiveConversation = this.UnarchiveConversation.bind(this);
        this.Unban = this.Unban.bind(this);
        this.UnmuteConversation = this.UnmuteConversation.bind(this);
        this.UserConversations = this.UserConversations.bind(this);
        this.Read = this.Read.bind(this);
        this.Subreddits = this.Subreddits.bind(this);
        this.Unread = this.Unread.bind(this);
        this.UnreadCount = this.UnreadCount.bind(this);
        this.CreateModmailConversation = this.CreateModmailConversation.bind(this);
    }
    BulkReadConversations(request, metadata) {
        const data = BulkReadConversationsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "BulkReadConversations", data, metadata);
        return promise.then((data) => BulkReadConversationsResponse.decode(_m0.Reader.create(data)));
    }
    GetConversations(request, metadata) {
        const data = GetConversationsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetConversations", data, metadata);
        return promise.then((data) => GetConversationsResponse.decode(_m0.Reader.create(data)));
    }
    CreateConversation(request, metadata) {
        const data = CreateConversationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "CreateConversation", data, metadata);
        return promise.then((data) => CreateConversationResponse.decode(_m0.Reader.create(data)));
    }
    GetConversation(request, metadata) {
        const data = GetConversationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetConversation", data, metadata);
        return promise.then((data) => GetConversationResponse.decode(_m0.Reader.create(data)));
    }
    CreateConversationMessage(request, metadata) {
        const data = CreateConversationMessageRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "CreateConversationMessage", data, metadata);
        return promise.then((data) => CreateConversationMessageResponse.decode(_m0.Reader.create(data)));
    }
    ApproveConversation(request, metadata) {
        const data = BasicConversationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "ApproveConversation", data, metadata);
        return promise.then((data) => ApproveConversationResponse.decode(_m0.Reader.create(data)));
    }
    ArchiveConversation(request, metadata) {
        const data = BasicConversationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "ArchiveConversation", data, metadata);
        return promise.then((data) => ArchiveConversationResponse.decode(_m0.Reader.create(data)));
    }
    DisapproveConversation(request, metadata) {
        const data = BasicConversationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "DisapproveConversation", data, metadata);
        return promise.then((data) => ApproveConversationResponse.decode(_m0.Reader.create(data)));
    }
    UnhighlightConversation(request, metadata) {
        const data = BasicConversationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UnhighlightConversation", data, metadata);
        return promise.then((data) => HighlightConversationResponse.decode(_m0.Reader.create(data)));
    }
    HighlightConversation(request, metadata) {
        const data = BasicConversationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "HighlightConversation", data, metadata);
        return promise.then((data) => HighlightConversationResponse.decode(_m0.Reader.create(data)));
    }
    MuteConversation(request, metadata) {
        const data = MuteConversationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "MuteConversation", data, metadata);
        return promise.then((data) => MuteConversationResponse.decode(_m0.Reader.create(data)));
    }
    TempBan(request, metadata) {
        const data = TempBanRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "TempBan", data, metadata);
        return promise.then((data) => TempBanResponse.decode(_m0.Reader.create(data)));
    }
    UnarchiveConversation(request, metadata) {
        const data = BasicConversationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UnarchiveConversation", data, metadata);
        return promise.then((data) => ArchiveConversationResponse.decode(_m0.Reader.create(data)));
    }
    Unban(request, metadata) {
        const data = BasicConversationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Unban", data, metadata);
        return promise.then((data) => TempBanResponse.decode(_m0.Reader.create(data)));
    }
    UnmuteConversation(request, metadata) {
        const data = BasicConversationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UnmuteConversation", data, metadata);
        return promise.then((data) => MuteConversationResponse.decode(_m0.Reader.create(data)));
    }
    UserConversations(request, metadata) {
        const data = BasicConversationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UserConversations", data, metadata);
        return promise.then((data) => ConversationUserData.decode(_m0.Reader.create(data)));
    }
    Read(request, metadata) {
        const data = BasicConversationsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Read", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    Subreddits(request, metadata) {
        const data = Empty.encode(request).finish();
        const promise = this.rpc.request(this.service, "Subreddits", data, metadata);
        return promise.then((data) => SubredditsResponse.decode(_m0.Reader.create(data)));
    }
    Unread(request, metadata) {
        const data = BasicConversationsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Unread", data, metadata);
        return promise.then((data) => Empty.decode(_m0.Reader.create(data)));
    }
    UnreadCount(request, metadata) {
        const data = Empty.encode(request).finish();
        const promise = this.rpc.request(this.service, "UnreadCount", data, metadata);
        return promise.then((data) => UnreadCountResponse.decode(_m0.Reader.create(data)));
    }
    CreateModmailConversation(request, metadata) {
        const data = CreateModmailConversationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "CreateModmailConversation", data, metadata);
        return promise.then((data) => CreateModmailConversationResponse.decode(_m0.Reader.create(data)));
    }
}
export const NewModmailDefinition = {
    name: "NewModmail",
    fullName: "devvit.plugin.redditapi.newmodmail.NewModmail",
    methods: {
        /** https://www.reddit.com/dev/api#POST_api_mod_bulk_read */
        bulkReadConversations: {
            name: "BulkReadConversations",
            requestType: BulkReadConversationsRequest,
            requestStream: false,
            responseType: BulkReadConversationsResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            34,
                            18,
                            32,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                            47,
                            98,
                            117,
                            108,
                            107,
                            47,
                            114,
                            101,
                            97,
                            100,
                        ]),
                        new Uint8Array([2, 24, 3]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_api_mod_conversations */
        getConversations: {
            name: "GetConversations",
            requestType: GetConversationsRequest,
            requestStream: false,
            responseType: GetConversationsResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            94,
                            18,
                            92,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            101,
                            110,
                            116,
                            105,
                            116,
                            121,
                            61,
                            123,
                            101,
                            110,
                            116,
                            105,
                            116,
                            121,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            115,
                            111,
                            114,
                            116,
                            61,
                            123,
                            115,
                            111,
                            114,
                            116,
                            125,
                            38,
                            115,
                            116,
                            97,
                            116,
                            101,
                            61,
                            123,
                            115,
                            116,
                            97,
                            116,
                            101,
                            125,
                        ]),
                        new Uint8Array([2, 64, 1]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_mod_conversations */
        createConversation: {
            name: "CreateConversation",
            requestType: CreateConversationRequest,
            requestStream: false,
            responseType: CreateConversationResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            24,
                            18,
                            22,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                        ]),
                        new Uint8Array([2, 24, 3]),
                        new Uint8Array([9, 58, 7, 115, 114, 95, 110, 97, 109, 101]),
                        new Uint8Array([2, 88, 1]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_api_mod_conversations_:conversation_id */
        getConversation: {
            name: "GetConversation",
            requestType: GetConversationRequest,
            requestStream: false,
            responseType: GetConversationResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            63,
                            18,
                            61,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                            47,
                            123,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            95,
                            105,
                            100,
                            125,
                            63,
                            109,
                            97,
                            114,
                            107,
                            82,
                            101,
                            97,
                            100,
                            61,
                            123,
                            109,
                            97,
                            114,
                            107,
                            95,
                            114,
                            101,
                            97,
                            100,
                            125,
                        ]),
                        new Uint8Array([2, 64, 1]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_mod_conversations_:conversation_id */
        createConversationMessage: {
            name: "CreateConversationMessage",
            requestType: CreateConversationMessageRequest,
            requestStream: false,
            responseType: CreateConversationMessageResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            42,
                            18,
                            40,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                            47,
                            123,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            95,
                            105,
                            100,
                            125,
                        ]),
                        new Uint8Array([2, 24, 3]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_mod_conversations_:conversation_id_approve */
        approveConversation: {
            name: "ApproveConversation",
            requestType: BasicConversationRequest,
            requestStream: false,
            responseType: ApproveConversationResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            50,
                            18,
                            48,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                            47,
                            123,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            95,
                            105,
                            100,
                            125,
                            47,
                            97,
                            112,
                            112,
                            114,
                            111,
                            118,
                            101,
                        ]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_mod_conversations_:conversation_id_archive */
        archiveConversation: {
            name: "ArchiveConversation",
            requestType: BasicConversationRequest,
            requestStream: false,
            responseType: ArchiveConversationResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            50,
                            18,
                            48,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                            47,
                            123,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            95,
                            105,
                            100,
                            125,
                            47,
                            97,
                            114,
                            99,
                            104,
                            105,
                            118,
                            101,
                        ]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_mod_conversations_:conversation_id_disapprove */
        disapproveConversation: {
            name: "DisapproveConversation",
            requestType: BasicConversationRequest,
            requestStream: false,
            responseType: ApproveConversationResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            53,
                            18,
                            51,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                            47,
                            123,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            95,
                            105,
                            100,
                            125,
                            47,
                            100,
                            105,
                            115,
                            97,
                            112,
                            112,
                            114,
                            111,
                            118,
                            101,
                        ]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#DELETE_api_mod_conversations_:conversation_id_highlight */
        unhighlightConversation: {
            name: "UnhighlightConversation",
            requestType: BasicConversationRequest,
            requestStream: false,
            responseType: HighlightConversationResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([8, 10, 6, 68, 69, 76, 69, 84, 69]),
                        new Uint8Array([
                            52,
                            18,
                            50,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                            47,
                            123,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            95,
                            105,
                            100,
                            125,
                            47,
                            104,
                            105,
                            103,
                            104,
                            108,
                            105,
                            103,
                            104,
                            116,
                        ]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_mod_conversations_:conversation_id_highlight */
        highlightConversation: {
            name: "HighlightConversation",
            requestType: BasicConversationRequest,
            requestStream: false,
            responseType: HighlightConversationResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            52,
                            18,
                            50,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                            47,
                            123,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            95,
                            105,
                            100,
                            125,
                            47,
                            104,
                            105,
                            103,
                            104,
                            108,
                            105,
                            103,
                            104,
                            116,
                        ]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_mod_conversations_:conversation_id_mute */
        muteConversation: {
            name: "MuteConversation",
            requestType: MuteConversationRequest,
            requestStream: false,
            responseType: MuteConversationResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            47,
                            18,
                            45,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                            47,
                            123,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            95,
                            105,
                            100,
                            125,
                            47,
                            109,
                            117,
                            116,
                            101,
                        ]),
                        new Uint8Array([2, 24, 4]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_mod_conversations_:conversation_id_temp_ban */
        tempBan: {
            name: "TempBan",
            requestType: TempBanRequest,
            requestStream: false,
            responseType: TempBanResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            51,
                            18,
                            49,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                            47,
                            123,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            95,
                            105,
                            100,
                            125,
                            47,
                            116,
                            101,
                            109,
                            112,
                            95,
                            98,
                            97,
                            110,
                        ]),
                        new Uint8Array([2, 24, 1]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_mod_conversations_:conversation_id_unarchive */
        unarchiveConversation: {
            name: "UnarchiveConversation",
            requestType: BasicConversationRequest,
            requestStream: false,
            responseType: ArchiveConversationResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            52,
                            18,
                            50,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                            47,
                            123,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            95,
                            105,
                            100,
                            125,
                            47,
                            117,
                            110,
                            97,
                            114,
                            99,
                            104,
                            105,
                            118,
                            101,
                        ]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_mod_conversations_:conversation_id_unban */
        unban: {
            name: "Unban",
            requestType: BasicConversationRequest,
            requestStream: false,
            responseType: TempBanResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            48,
                            18,
                            46,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                            47,
                            123,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            95,
                            105,
                            100,
                            125,
                            47,
                            117,
                            110,
                            98,
                            97,
                            110,
                        ]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_mod_conversations_:conversation_id_unmute */
        unmuteConversation: {
            name: "UnmuteConversation",
            requestType: BasicConversationRequest,
            requestStream: false,
            responseType: MuteConversationResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            49,
                            18,
                            47,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                            47,
                            123,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            95,
                            105,
                            100,
                            125,
                            47,
                            117,
                            110,
                            109,
                            117,
                            116,
                            101,
                        ]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_api_mod_conversations_:conversation_id_user */
        userConversations: {
            name: "UserConversations",
            requestType: BasicConversationRequest,
            requestStream: false,
            responseType: ConversationUserData,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            47,
                            18,
                            45,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                            47,
                            123,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            95,
                            105,
                            100,
                            125,
                            47,
                            117,
                            115,
                            101,
                            114,
                        ]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_mod_conversations_read */
        read: {
            name: "Read",
            requestType: BasicConversationsRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            29,
                            18,
                            27,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                            47,
                            114,
                            101,
                            97,
                            100,
                        ]),
                        new Uint8Array([2, 24, 3]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_api_mod_conversations_subreddits */
        subreddits: {
            name: "Subreddits",
            requestType: Empty,
            requestStream: false,
            responseType: SubredditsResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            35,
                            18,
                            33,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                            47,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            115,
                        ]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#POST_api_mod_conversations_unread */
        unread: {
            name: "Unread",
            requestType: BasicConversationsRequest,
            requestStream: false,
            responseType: Empty,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([6, 10, 4, 80, 79, 83, 84]),
                        new Uint8Array([
                            31,
                            18,
                            29,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                            47,
                            117,
                            110,
                            114,
                            101,
                            97,
                            100,
                        ]),
                        new Uint8Array([2, 24, 3]),
                    ],
                },
            },
        },
        /** https://www.reddit.com/dev/api#GET_api_mod_conversations_unread_count */
        unreadCount: {
            name: "UnreadCount",
            requestType: Empty,
            requestStream: false,
            responseType: UnreadCountResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            37,
                            18,
                            35,
                            47,
                            97,
                            112,
                            105,
                            47,
                            109,
                            111,
                            100,
                            47,
                            99,
                            111,
                            110,
                            118,
                            101,
                            114,
                            115,
                            97,
                            116,
                            105,
                            111,
                            110,
                            115,
                            47,
                            117,
                            110,
                            114,
                            101,
                            97,
                            100,
                            47,
                            99,
                            111,
                            117,
                            110,
                            116,
                        ]),
                    ],
                },
            },
        },
        /** Creates a new modmail conversation. */
        createModmailConversation: {
            name: "CreateModmailConversation",
            requestType: CreateModmailConversationRequest,
            requestStream: false,
            responseType: CreateModmailConversationResponse,
            responseStream: false,
            options: {},
        },
    },
};
